<template>
  <div class="hero-section">
    <b-container>
      <b-row class="align-items-center">
        <b-col cols="12" md="7" class="hero-section__content">
          <h1 class="hero-section__title">
            <span class="hero-section__title-top">Professional</span>
            <span class="hero-section__title-main">Garage Door</span>
            <span class="hero-section__title-bottom">Solutions</span>
          </h1>

          <p class="hero-section__subtitle">
            Expert service for Englewood, NJ and surrounding areas
          </p>

          <!-- Services Grid -->
          <div class="services-grid">
            <div class="service-item">
              <div class="service-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M9 11L12 14L22 4"
                    stroke="#0d47a1"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16"
                    stroke="#0d47a1"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <RouterLink
                to="/services/new-garage-door-installations-residential-commercial"
                class="text-decoration-none"
                ><span>New Garage Door Installations</span></RouterLink
              >
            </div>

            <div class="service-item">
              <div class="service-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M9 11L12 14L22 4"
                    stroke="#0d47a1"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16"
                    stroke="#0d47a1"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <RouterLink
                to="services/replacement-old-damaged-doors"
                class="text-decoration-none"
                ><span>Replacement of old doors</span></RouterLink
              >
            </div>

            <div class="service-item">
              <div class="service-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M9 11L12 14L22 4"
                    stroke="#0d47a1"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16"
                    stroke="#0d47a1"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <RouterLink
                to="services/roller-and-hinge-repair"
                class="text-decoration-none"
                ><span>Rollers and Hinge repair</span></RouterLink
              >
            </div>

            <div class="service-item">
              <div class="service-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M9 11L12 14L22 4"
                    stroke="#0d47a1"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M21 12V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16"
                    stroke="#0d47a1"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
              <RouterLink
                to="/services/opener-repair-and-troubleshooting"
                class="text-decoration-none"
                ><span>Opener Repairs</span></RouterLink
              >
            </div>
          </div>

          <!-- CTA Section -->
          <div class="cta-section">
            <router-link to="/services">
              <b-button class="hero-section__btn">
                View All Services
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M5 12H19M19 12L12 5M19 12L12 19"
                    stroke="white"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </b-button>
            </router-link>

            <a href="tel:5514080587" class="contact-info">
              <div class="contact-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M22 16.92V19.92C22 20.4896 21.5523 20.9725 20.9856 20.9983C20.9056 21.0007 20.8254 21 20.745 20.9967C17.5625 20.7479 14.5398 19.5461 11.9814 17.5416C9.58734 15.6798 7.67339 13.2269 6.41992 10.4134C4.48306 7.55379 3.41191 4.23537 3.30693 0.829765C3.29346 0.353926 3.65569 -0.0407526 4.1296 -0.00289272C4.18541 -0.000967419 4.24124 0.000967419 4.29707 0.00289272H7.29707C8.01696 -0.00403735 8.60958 0.521155 8.69716 1.23192C8.73037 1.54095 8.77305 1.84903 8.8252 2.15518C9.05656 3.47229 9.46138 4.75073 10.0271 5.96022C10.2523 6.48009 10.091 7.08806 9.64263 7.41871L8.21479 8.5418C9.77581 11.3243 12.1039 13.5483 14.9643 14.9651L16.0808 13.5418C16.4171 13.1008 17.0369 12.9425 17.5663 13.1639C18.8063 13.7181 20.1171 14.1134 21.467 14.3392C22.1852 14.4266 22.7168 15.0317 22.7098 15.757L22 16.92Z"
                    fill="#0d47a1"
                  />
                </svg>
              </div>
              <div href="tel:5514080587" class="contact-text">
                <span class="contact-label">Emergency?</span>
                <span class="contact-number">Call 24/7</span>
              </div>
            </a>
          </div>
        </b-col>

        <b-col cols="12" md="5" class="d-none d-md-block">
          <div class="hero-stats">
            <!-- <div class="stat-card">
              <div class="stat-number">500+</div>
              <div class="stat-label">Projects Done</div>
            </div> -->
            <div class="stat-card">
              <div class="stat-number">24/7</div>
              <div class="stat-label">Support</div>
            </div>
            <div class="stat-card">
              <div class="stat-number">100%</div>
              <div class="stat-label">Satisfaction</div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-container>

    <!-- Decorative Elements -->
    <div class="decorative-circle decorative-circle-1"></div>
    <div class="decorative-circle decorative-circle-2"></div>
    <div class="decorative-line"></div>
  </div>
</template>

<script>
import { RouterLink } from "vue-router";

export default {
  name: "HeroSection",
};
</script>

<style lang="scss" scoped>
.hero-section {
  position: relative;
  background-image: url("../assets/imgs/garage-door-styles.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  min-height: 600px;
  overflow: hidden;
  display: flex;
  align-items: center;
  padding: 30px 0;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(
      135deg,
      rgb(79 97 125 / 70%) 0%,
      rgb(15 11 11 / 40%) 100%
    );
    z-index: 1;
  }

  > * {
    position: relative;
    z-index: 2;
  }

  &__content {
    padding-left: 30px;
  }

  // Title Styling
  &__title {
    display: flex;
    flex-direction: column;
    margin-bottom: 5px;
    animation: fadeInLeft 1s ease;

    &-top {
      font-size: 24px;
      font-weight: 600;
      color: rgba(255, 255, 255, 0.9);
      text-transform: uppercase;
      letter-spacing: 3px;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8);
    }

    &-main {
      font-size: 56px;
      font-weight: 900;
      color: #3072d9;
      text-transform: uppercase;
      line-height: 1;
      text-shadow: 0 4px 8px rgba(0, 0, 0, 0.8);
      margin: 5px 0;
    }

    &-bottom {
      font-size: 48px;
      font-weight: 800;
      color: white;
      text-transform: uppercase;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8);
    }
  }

  &__subtitle {
    font-size: 18px;
    color: rgba(255, 255, 255, 0.95);
    font-weight: 500;
    margin-bottom: 20px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
    animation: fadeInLeft 1.2s ease;
    span {
      color: #3072d9;
      font-weight: 700;
    }
  }

  // Services Grid
  .services-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
    margin-bottom: 15px;
    animation: fadeInUp 1.4s ease;

    .service-item {
      display: flex;
      align-items: center;
      gap: 12px;
      background: rgba(255, 255, 255, 0.1);
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.15);
      padding: 15px;
      border-radius: 12px;
      transition: all 0.3s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.2);
        transform: translateY(-3px);
      }

      .service-icon {
        width: 40px;
        height: 40px;
        background: white;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
      }

      span {
        color: white;
        font-size: 15px;
        font-weight: 600;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
      }
    }
  }

  // CTA Section
  .cta-section {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
    animation: fadeInUp 1.6s ease;
  }

  &__btn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    font-size: 16px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: white;
    background: #3072d9;
    border: none;
    border-radius: 50px;
    padding: 16px 32px;
    transition: all 0.3s ease;
    box-shadow: 0 4px 15px rgba(13, 71, 161, 0.4);

    &:hover {
      background: #0a3a82;
      transform: translateY(-2px);
      box-shadow: 0 6px 20px rgba(13, 71, 161, 0.6);
    }

    svg {
      transition: transform 0.3s ease;
    }

    &:hover svg {
      transform: translateX(5px);
    }
  }

  .contact-info {
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(255, 255, 255, 0.15);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.2);
    padding: 12px 20px;
    border-radius: 50px;

    .contact-icon {
      width: 48px;
      height: 48px;
      background: white;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .contact-text {
      display: flex;
      flex-direction: column;

      .contact-label {
        font-size: 12px;
        color: rgba(255, 255, 255, 0.8);
        font-weight: 500;
      }

      .contact-number {
        font-size: 16px;
        color: white;
        font-weight: 700;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
      }
    }
  }

  // Stats Cards
  .hero-stats {
    display: flex;
    flex-direction: column;
    gap: 20px;
    padding-left: 30px;

    .stat-card {
      background: rgba(255, 255, 255, 0.1);
      backdrop-filter: blur(10px);
      border: 1px solid rgba(255, 255, 255, 0.2);
      padding: 25px;
      border-radius: 16px;
      text-align: center;
      transition: all 0.3s ease;
      animation: fadeInRight 1s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.15);
        transform: translateX(-10px);
      }

      .stat-number {
        font-size: 42px;
        font-weight: 900;
        color: #3072d9;
        text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8);
        margin-bottom: 5px;
      }

      .stat-label {
        font-size: 16px;
        color: white;
        font-weight: 600;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
      }
    }
  }

  // Decorative Elements
  .decorative-circle {
    position: absolute;
    border-radius: 50%;
    background: rgba(13, 71, 161, 0.1);
    z-index: 1;

    &-1 {
      width: 400px;
      height: 400px;
      top: -200px;
      right: -100px;
      animation: float 8s ease-in-out infinite;
    }

    &-2 {
      width: 300px;
      height: 300px;
      bottom: -150px;
      left: -50px;
      animation: float 6s ease-in-out infinite reverse;
    }
  }

  .decorative-line {
    position: absolute;
    width: 200px;
    height: 4px;
    background: linear-gradient(90deg, transparent, #0d47a1, transparent);
    top: 50%;
    right: 0;
    z-index: 1;
    animation: pulse 2s ease-in-out infinite;
  }

  // Animations
  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeInLeft {
    from {
      opacity: 0;
      transform: translateX(-30px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeInRight {
    from {
      opacity: 0;
      transform: translateX(30px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes float {
    0%,
    100% {
      transform: translateY(0) rotate(0deg);
    }
    50% {
      transform: translateY(-20px) rotate(5deg);
    }
  }

  @keyframes pulse {
    0%,
    100% {
      opacity: 0.3;
    }
    50% {
      opacity: 0.8;
    }
  }

  // Responsive Design
  @media (max-width: 991.99px) {
    min-height: 550px;
    padding: 30px 0;

    &__title {
      &-top {
        font-size: 20px;
      }
      &-main {
        font-size: 44px;
      }
      &-bottom {
        font-size: 36px;
      }
    }
  }

  @media (max-width: 767.99px) {
    min-height: auto;
    padding: 20px 0;

    &__content {
      padding-left: 15px;
    }

    &__title {
      &-top {
        font-size: 16px;
        letter-spacing: 2px;
      }
      &-main {
        font-size: 36px;
      }
      &-bottom {
        font-size: 28px;
      }
    }

    &__subtitle {
      font-size: 16px;
    }

    .services-grid {
      gap: 12px;

      .service-item {
        padding: 12px;

        .service-icon {
          width: 35px;
          height: 35px;

          svg {
            width: 20px;
            height: 20px;
          }
        }

        span {
          font-size: 13px;
        }
      }
    }

    .cta-section {
      flex-direction: column;
      align-items: flex-start;
    }

    &__btn {
      font-size: 14px;
      padding: 14px 28px;
    }

    .decorative-circle {
      &-1 {
        width: 250px;
        height: 250px;
      }
      &-2 {
        width: 200px;
        height: 200px;
      }
    }
  }

  @media (max-width: 575.99px) {
    &__title {
      &-top {
        font-size: 14px;
      }
      &-main {
        font-size: 28px;
      }
      &-bottom {
        font-size: 24px;
      }
    }

    &__subtitle {
      font-size: 14px;
      margin-bottom: 10px;
    }

    .services-grid {
      grid-template-columns: 1fr;
    }

    .hero-badge {
      padding: 6px 16px;

      span {
        font-size: 11px;
      }
    }
  }
}
</style>
